import React from "react";
import Database from "@/components/database/Database";
import TitleUpdater from "../components/common/layout/TitleUpdater";

export default function DatabasePage() {

  return (
    <div>
      <TitleUpdater />
      <Database />
    </div>
  );
}
